import React, { cloneElement } from 'react';
import { Button, Modal, FormControl, ControlLabel, Alert, FormGroup, Checkbox } from "react-bootstrap";
import moment from 'moment';
import immutable from "immutable";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import util from "./../../lib/util.js";
import PtoDetail from "./pto-detail.jsx";

export default class PtoList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: null,
            deniableTypeReasonList: [],
            showDialog: false,
            dialogTitle: "Request Time-Off",
            action: "",
            list: [],
            selectedId: 0,
            selectedType: "",
            selectedCanBeDenied: false,
            filterDays: 180
        }

        this.loadResource = this.loadResource.bind(this);
        this.loadList = this.loadList.bind(this);
        this.delete = this.delete.bind(this);
        this.approve = this.approve.bind(this);
        this.openDetail = this.openDetail.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.filterChanged = this.filterChanged.bind(this);
        this.onDetailSaved = this.onDetailSaved.bind(this);
        this.renderMobile = this.renderMobile.bind(this);
    }

    componentDidMount() {
        const self = this;
        if (self.props.onInit)
            self.props.onInit();

        self.loadResource(() => { self.loadList(self.state.filterDays); } )
    }

    loadResource(callback) {
        const self = this;

        const apiCalls = [ajax.api().get('get-pto-resource')];

        // we want to know which requests can be DECLINED or just CONSULT HR
        if ((this.props.userRole || "").toLowerCase() == "supervisor")
            apiCalls.push(ajax.api().get('get-pto-deniable'));

        Promise.all(apiCalls)
            .then(res => {
                const clone = immutable.fromJS(self.state).toJS();
                clone.resource = res[0].data;

                if (res.length > 1)
                    clone.deniableTypeReasonList = res[1].data;

                self.setState(clone, 
                    () => { 
                        if (callback) callback(); 
                    });
            }).catch(function (err) {
                let data = err.response? err.response.data : err;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    loadList(filterDays) {

        const self = this;
        const userRole = this.props.userRole
        let url = `get-pto-list/${userRole}`;
        if (filterDays) {
            const dateStart = moment().add((filterDays * -1), "days");
            url = `get-pto-list/${userRole}/${dateStart.format("YYYY-MM-DD")}`;
        }

        ajax.api()
            .get(url)
            .then(res => {
                const clone = immutable.fromJS(self.state).toJS();
                clone.list = res.data;
                clone.filterDays = filterDays;
                clone.showDialog = false; // when called by onDetailChanged()
                self.setState(clone, 
                    () => { 
                        if (self.props.onLoad)
                            self.props.onLoad(res.data); 
                    });
            }).catch(function (err) {
                let data = err.response? err.response.data : err;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onDetailSaved() {
        this.closeDialog();
        this.loadList(this.state.filterDays);

        if (this.props.onSaved)
            this.props.onSaved();
    }

    approve(ptoId) {
        const self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Approving request. Please wait..."            
        });

        ajax.api()
            .post('update-pto', { ptoId: ptoId, action: 'approve' })
            .then(function(res){
                context.message({
                    show: false
                });
                
                self.loadList(self.state.filterDays);
            })
            .catch(function(err) {
                const message = err.response.data.exceptionMessage || err.response.data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: message,
                    buttons: "close"});
            });
    }

    delete(ptoId) {
        const self = this;
        let clone = immutable.fromJS(this.state).toJS();
        context.message({
            title: "Cancel Time-Off",
            show : true,
            type : "info",
            message: "This will cancel your Time-Off request. Are you sure you want to continue?",
            buttons: "yes,no"
        }, function(button, s) {
            // s is ptoId, ptoId is set as the 3rd parameter of context.message (see bottom)
            if (button === "yes") {
                context.message({
                    show: true,
                    type: "loading",
                    message: "Deleting request. Please wait..."            
                });
                ajax.api()
                    .delete("delete-pto/" + s)
                    .then(function(res) {
                        context.message({
                            show: false
                        });

                        clone.list = clone.list.filter(function(o) { return o.ptoId != s; });
                        clone.message = 'Deleted successfully';
                        self.setState(clone);
                    })
                    .catch(function(err) {
                        const message = err.response.data.exceptionMessage || err.response.data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: message,
                            buttons: "close"});
                    });                  
            }
        }, ptoId);
    }

    openDetail(ptoId, action, type) {
        const clone = immutable.fromJS(this.state);

        clone.selectedId = ptoId;
        clone.showDialog = true;
        clone.action = action;

        switch (action) {
            case "create":
                clone.dialogTitle = "Request Time-Off";
                clone.selectedType = type? type : ""; // can default Type only when creation
                break;
            case "edit":
                clone.dialogTitle = "Edit Time-Off Request";
                break;
            // PAP-397 - Supervisor notes is NOT a required field when approve a TO request (just approve right away)
            // case "approve":
            //     clone.dialogTitle = "Approve Time-Off";
            //     break;
            case "deny":
                clone.selectedType = type? type : "";
                clone.dialogTitle = "Decline " + (clone.selectedType.includes("FTO")? "FTO" : "Time-Off");
                break;
            case "consult":
                clone.dialogTitle = "Consult HR";
                break;
            case "cancel":
                clone.dialogTitle = "Cancel Time-Off Request";
                break;
        }
        this.setState(clone);
    }

    closeDialog() {
        this.setState({ showDialog: false });
    }

    filterChanged(evt) {
        if (this.props.onFilterChanged)
            this.props.onFilterChanged();

        this.loadList(parseInt(evt.target.value));
    }

    canBeDenied(pto) {
        if (this.state.deniableTypeReasonList.filter(o => o.typeCode == pto.code && (o.reasonCode == '' || o.reasonCode == pto.reasonCode)).length > 0)
            return true; 
        
        return false;
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        const self = this;
        const isMobile = this.isIos() || this.isAndroid();
        const res = this.state.resource;
        const userRole = this.props.userRole;
        const isSupervisor = userRole == "supervisor";
        let items = this.state.list;

        const ddlFilter = <FormControl componentClass="select" defaultValue={this.state.filterDays} onChange={this.filterChanged}>
                            <option key="30" value="30">Past month</option>
                            <option key="90" value="90">Past 3 months</option>
                            <option key="180" value="180">Past 6 months</option>
                            <option key="365" value="365">Past 12 months</option>
                        </FormControl>;

        const dlgDetail = <Modal className="ap-pto-dialog" show={this.state.showDialog} onHide={this.closeDialog} backdrop="static">
                            <Modal.Header closeButton={true}>
                                <Modal.Title className="ap-pto-dialog-title">
                                    <i className="fa fa-calendar-o" /> {this.state.dialogTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <PtoDetail ptoId={this.state.selectedId} onSaved={this.onDetailSaved} onClosed={this.closeDialog} userRole={userRole} action={this.state.action}
                                    canBeDenied={self.state.selectedId == 0? false : this.canBeDenied(items.filter(o => o.ptoId == self.state.selectedId)[0])}
                                    switchToApproveOrDeny={(action) => this.openDetail(this.state.selectedId, action)} defaultType={this.state.selectedType} />
                            </Modal.Body>
                        </Modal>;

        const statusEnum = {
            Requested: { Icon: "fa fa-minus-circle orange", Label: "Requested", Description: "Awaiting Approval"},
            Pending: { Icon: "fa fa-minus-circle yellow", Label: "Pending", Description: "HR Consulation"},
            Approved: { Icon: "fa fa-check-circle green", Label: "Approved", Description: "Approved & Awaiting Payroll Processing"},
            Processed: { Icon: "fa fa-check-circle blue", Label: "Processed", Description: "Payroll Processed"},
            Cancelled: { Icon: "fa fa-times-circle grey", Label: "Cancelled", Description: "Cancelled"},
            Denied: { Icon: "fa fa-times-circle red", Label: "Denied", Description: "Denied"}
        }

        if (isMobile)
            return this.renderMobile(dlgDetail, ddlFilter, statusEnum);

        // COLUMN widths
        const colWidth = isSupervisor?
            {
                Name: "col-md-2",
                Date: "col-md-2",
                Type: "col-md-1",
                Unit: "col-md-1",
                Status: "col-md-1",
                Reason: "col-md-3",
                Buttons: "col-md-2"
            } :
            {
                Name: "ap-hidden",
                Date: "col-md-2",
                Type: "col-md-1",
                Unit: "col-md-1",
                Status: "col-md-2",
                Reason: "col-md-5",
                Buttons: "col-md-1"
            };

        const header = {
            Name: <div key="hdr_0" className={colWidth.Name}>Name</div>,
            Type: <div key="hdr_1" className={colWidth.Type}>Type</div>,
            Date: <div key="hdr_2" className={colWidth.Date}>Date</div>,
            Unit: <div key="hdr_3" className={colWidth.Unit}>Hours</div>,
            Status: <div key="hdr_4" className={colWidth.Status}>Status</div>,
            Reason: <div key="hdr_5" className={colWidth.Reason}>Reason for Request</div>
        }

        const gridRows = [];

        if (items.length == 0) {
            gridRows.push(
                <div className="row ap-pto-list-item" key="pto_empty">
                    <div className="col-md-12">
                        No records found.
                    </div>
                </div>);
        }
        else {
            for (let i=0; i<items.length; i++) {
                const readOnly = (items[i].statusCode != "Requested");
                const isApproved = (items[i].statusCode == "Approved");
                let btnButtons = null;

                let period = moment(items[i].fromDate).format("MM/DD/YYYY");
                let toDate = moment(items[i].toDate).format("MM/DD/YYYY");

                if (period != toDate)
                    period = `${period} - ${toDate}`;

                if (!readOnly || isApproved) {
                    // status and role-based buttons
                    const button = {
                        Edit: <a onClick={() => this.openDetail(items[i].ptoId, "edit")} key="edit"><i className='fa fa-pencil-square-o'></i></a>,
                        Cancel: <a onClick={() => this.openDetail(items[i].ptoId, "cancel")} key="cancel"><i className='fa fa-times'></i></a>,
                        Approve: <button key="approve" className="approve" onClick={() => this.approve(items[i].ptoId)}>Approve</button>,
                        Deny: self.canBeDenied(items[i])?
                                <button key="deny" className="deny" onClick={() => this.openDetail(items[i].ptoId, "deny", items[i].code)}>Decline</button>
                                : 
                                <button key="consult" className="deny" onClick={() => this.openDetail(items[i].ptoId, "consult")}>Consult HR</button>
                    };

                    if (isSupervisor)
                        btnButtons = isApproved? [button.Cancel] : [button.Approve, button.Deny, button.Edit];
                    else
                        btnButtons = isApproved? [] : [button.Edit, button.Cancel];
                }

                const column = {
                    Name: <div key="col_0" className={`${colWidth.Name} text employee-name`} title={items[i].peopleName}>
                        {items[i].peopleName}</div>,
                    Date: <div key="col_1" className={`${colWidth.Date} date`}>
                        {period}</div>,
                    Type: <div key="col_2" className={`${colWidth.Type} type`}>
                        {res[`typeDesc${items[i].code}`]}</div>,
                    Unit: <div key="col_3" className={`${colWidth.Unit} unit`}>
                        {items[i].unit}</div>,
                    Status: <div key="col_4" className={`${colWidth.Status} status`}>
                        <i className={statusEnum[items[i].statusCode].Icon}></i> {statusEnum[items[i].statusCode].Label}</div>,
                    Reason: <div key="col_5" className={`${colWidth.Reason} text reason`} title={items[i].reasonDesc}>
                        {items[i].reasonDesc}</div>,
                    Buttons: <div key="col_6" className={`${colWidth.Buttons} button-panel`}>
                        {btnButtons}</div>
                };

                gridRows.push(
                    <div className={`row ap-pto-list-item ${readOnly? "" : "open"}`} key={`pto_${i}`}>
                        { isSupervisor? 
                            [column.Name, column.Status , column.Date, column.Unit, column.Type, column.Reason, column.Buttons]
                            : 
                            [column.Date, column.Type, column.Unit, column.Status, column.Reason, column.Buttons]
                        }
                    </div>
                );
            }
        }
        
        return (
            <div className="col-md-12 ap-pto-list">
                {
                    (this.props.title && this.props.title != "")?
                    <div className="row ap-pto-list-title" key="pto_title">
                        <div className="col-md-4">
                        </div>
                        <div className="col-md-4">
                            {this.props.title}
                        </div>
                        <div className="col-md-4 ap-pto-list-filter">
                            <ControlLabel>Filter by:</ControlLabel>
                            {ddlFilter}
                        </div>
                    </div>
                    :
                    []
                }
                <div className="row ap-pto-list-header" key="pto_header">
                    { isSupervisor? 
                        [header.Name, header.Status , header.Date, header.Unit, header.Type, header.Reason]
                        : 
                        [header.Date, header.Type, header.Unit, header.Status, header.Reason, header.Buttons]
                    }
                </div>
                <div className="row" key="pto_body">
                    <div className="col-md-12 item-container">
                        {gridRows}
                    </div>
                </div>
                <div className="row ap-pto-list-footer" key="pto_footer">
                    <div className="col-md-12 ap-content-spaced-evenly">
                        <span><i className={statusEnum.Requested.Icon}></i> {statusEnum.Requested.Label} - <label>{statusEnum.Requested.Description}</label></span>
                        <span><i className={statusEnum.Pending.Icon}></i> {statusEnum.Pending.Label} - <label>{statusEnum.Pending.Description}</label></span>
                        <span><i className={statusEnum.Approved.Icon}></i> {statusEnum.Approved.Label} - <label>{statusEnum.Approved.Description}</label></span>
                        <span><i className={statusEnum.Processed.Icon}></i> {statusEnum.Processed.Label} - <label>{statusEnum.Processed.Description}</label></span>
                        <span>|</span>
                        <span><i className={statusEnum.Denied.Icon}></i> {statusEnum.Denied.Label}</span>
                        <span><i className={statusEnum.Cancelled.Icon}></i> {statusEnum.Cancelled.Label}</span>
                    </div>
                </div>
                {dlgDetail}
            </div>);
    }

    renderMobile(dlgDetail, ddlFilter, statusEnum) {

        const self = this;
        const res = this.state.resource;
        const userRole = this.props.userRole;
        const isSupervisor = userRole == "supervisor";
        let items = this.state.list;

        // COLUMN widths
        const colWidth = isSupervisor?
            {
                Name: "col-xs-4",
                Date: "col-xs-4",
                Type: "col-xs-3",
                Unit: "col-xs-4",
                Status: "col-xs-4",
                EditCancelButtons: "col-xs-1",
                ApproveDenyButtons: "col-xs-4",
                Reason: "col-xs-4"
            } :
            {
                Name: "ap-hidden",
                Date: "col-xs-4",
                Type: "col-xs-3",
                Unit: "col-xs-4",
                Status: "col-xs-3",
                EditCancelButtons: "col-xs-2",
                ApproveDenyButtons: "ap-hidden",
                Reason: "col-xs-5"
            };

        const gridRows = [];

        if (items.length == 0) {
            gridRows.push(
                <div className="row ap-pto-list-item" key="pto_empty">
                    <div className="col-xs-12">
                        No records found.
                    </div>
                </div>);
        }
        else {
            for (let i=0; i<items.length; i++) {
                const readOnly = (items[i].statusCode != "Requested");
                const isApproved = (items[i].statusCode == "Approved");
                let btnEditCancel = null;
                let btnApproveDeny = null;

                let period = moment(items[i].fromDate).format("MM/DD/YY");
                let toDate = moment(items[i].toDate).format("MM/DD/YY");

                if (period != toDate)
                    period = `${period} - ${toDate}`;

                if (!readOnly || isApproved) {
                    // status and role-based buttons
                    const button = {
                        Edit: <a onClick={() => this.openDetail(items[i].ptoId, "edit")} key="edit"><i className='fa fa-pencil-square-o'></i></a>,
                        Cancel: <a onClick={() => this.openDetail(items[i].ptoId, "cancel")} key="cancel"><i className='fa fa-times'></i></a>,
                        Approve: <button key="approve" className="approve" onClick={() => this.approve(items[i].ptoId)}>Approve</button>,
                        Deny: self.canBeDenied(items[i])?
                                <button key="btn_3" className="deny" onClick={() => this.openDetail(items[i].ptoId, "deny", items[i].code)}>Decline</button>
                                : 
                                <button key="btn_3" className="deny" onClick={() => this.openDetail(items[i].ptoId, "consult")}>Consult HR</button>
                    };
                    
                    if (isSupervisor) {
                        btnEditCancel = isApproved? [button.Cancel] : [button.Edit];
                        btnApproveDeny = isApproved? null : [button.Approve, button.Deny];
                    }
                    else {
                        btnEditCancel = isApproved? null : [button.Edit, button.Cancel];
                        btnApproveDeny = null;
                    }
                }

                const column = {
                    Name: <div key="col_0" className={`${colWidth.Name} text employee-name`} title={items[i].peopleName}>
                        {items[i].peopleName}</div>,
                    Date: <div key="col_1" className={`${colWidth.Date} date`}>
                        {period}</div>,
                    Type: <div key="col_2" className={`${colWidth.Type} type`}>
                        {res[`typeDesc${items[i].code}`]}</div>,
                    Unit: <div key="col_3" className={`${colWidth.Unit} unit`}>
                        {items[i].unit} hr(s)</div>,
                    Status: <div key="col_4" className={`${colWidth.Status} status`}>
                        <i className={statusEnum[items[i].statusCode].Icon}></i> {statusEnum[items[i].statusCode].Label}</div>,
                    Reason: <div key="col_5" className={`${colWidth.Reason} text reason`} title={items[i].reasonDesc}>
                        {items[i].reasonDesc}</div>,
                    EditCancelButtons: <div key="col_6" className={`${colWidth.EditCancelButtons} button-panel edit-cancel`}>
                        {btnEditCancel}</div>,
                    ApproveDenyButtons: <div key="col_7" className={`${colWidth.ApproveDenyButtons} button-panel approve-deny`}>
                        {btnApproveDeny}</div>
                };

                gridRows.push(
                    <div className={`row ap-pto-list-item ${readOnly? "" : "open"}`} key={`pto_${i}`}>
                        { isSupervisor? 
                            [column.Name, column.Date, column.Type, column.EditCancelButtons, (readOnly? column.Status : column.ApproveDenyButtons), column.Unit, column.Reason]
                            : 
                            [column.Status, column.Date, column.Type, column.EditCancelButtons, <div key="col_blank" className={colWidth.Status}/>, column.Unit, column.Reason]
                        }
                    </div>
                );
            }
        }
        
        return (
            <div className="col-xs-12 ap-pto-list">
                {
                    (this.props.title && this.props.title != "")?
                    <div className="row ap-pto-list-title" key="pto_title">
                        <div className="col-xs-4">
                        </div>
                        <div className="col-xs-4">
                            {this.props.title}
                        </div>
                        <div className="col-xs-4 ap-pto-list-filter-mobile">
                            {ddlFilter}
                        </div>
                    </div>
                    :
                    []
                }
                <div className="row ap-pto-list-header" key="pto_header">
                    {isSupervisor? <div className={colWidth.Name}>Name</div> : <div className={colWidth.Status}>Status</div>}
                    <div className={colWidth.Date}>Date/Hours</div>
                    <div className={colWidth.Reason}>Type/Reason</div>
                </div>
                <div className="row" key="pto_body">
                    <div className={isSupervisor? "col-xs-12 supervisor" : "col-xs-12"}>
                        {gridRows}
                    </div>
                </div>
                {dlgDetail}
            </div>);

    }
}